import React, { useCallback } from 'react';
import { Button } from 'core/components';
import { useHistory } from 'react-router-dom';
import $ude from 'app/stores/ude/$ude';
import type { Query } from '@kentik/ui-shared/query/query.types';

interface ViewInUdeButtonProps {
  query: Query;
}

/**
 * Button that opens the Universal Data Explorer with the given query pre-selected.
 * Stashes the query via $ude.setPendingQuery and navigates to the UDE page, where
 * UdePanel consumes the pending query on mount.
 */
function ViewInUdeButton({ query }: ViewInUdeButtonProps) {
  const history = useHistory();

  const handleClick = useCallback(() => {
    if (!query) {
      return;
    }

    $ude.setPendingQuery({
      query,
      chart: { type: query.viz?.type || 'stackedArea', enable: true }
    });
    // /v4/ude (BoardWrapperView) forges a new board + UDE panel; UdePanel then
    // consumes the pending query on mount. /v4/core/ude renders a bare
    // PanelEditView with no board/panel and 404s, so it must not be used here.
    history.push('/v4/ude');
  }, [query, history]);

  return <Button small minimal icon="series-search" text="View in UDE" onClick={handleClick} />;
}

export default ViewInUdeButton;
